<template lang="pug">
aside.sidebar(ref="sidebar" :style="sidebarStyle" :class="sidebarClass")
	slot {{ sidebarScrollTop }}

	.sidebar-toggle(:class="{ floating: collapsed }")
		button.button.button--ghost.button--icon-only(@click="toggleSidebar" v-if="showToggleBtn"  title="Toggle Sidebar")
			i.fa.fa-angle-double-left(v-if="!collapsed")
			i.fa.fa-angle-double-right(v-else)
</template>

<script>
import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import ViewportAware from "@/mixins/ViewportAware";

@Component()
class Sidebar extends Mixins(ViewportAware) {
	@Prop(Boolean) collapsed;
	@Prop(Number) scrollTop;
	@Prop({ default: true }) showToggleBtn;

	sidebarHeight = 100;

	get sidebarScrollTop() {
		const st = this.scrollTop;
		if (this.$el) this.$el.scrollTop = st - 84;
		return st;
	}

	get sidebarStyle() {
		return {
			height: this.sidebarHeight + "px",
			"max-height": this.sidebarHeight + "px"
		};
	}

	get sidebarClass() {
		return {
			collapsed: this.collapsed == true
		};
	}

	resizeSidebar() {
		Vue.nextTick(() => {
			const h = this.viewportData.viewportSize.h;
			if (this.$el)
				this.sidebarHeight = h - this.$el.getBoundingClientRect().top;
			if (this.sidebarHeight === 0) this.sidebarHeight = h;
		});
	}

	mounted() {
		this.$watch("viewportData.viewportSize.h", this.resizeSidebar);
		this.resizeSidebar();
		// also resize at various intervals to make absolutely sure we have the correct size
		setTimeout(this.resizeSidebar, 100);
		// no seriously, browser viewports are weird
		setTimeout(this.resizeSidebar, 1000);
		setTimeout(this.resizeSidebar, 5000);
	}

	toggleSidebar() {
		if (this.collapsed) this.$emit("sidebar:uncollapse");
		else this.$emit("sidebar:collapse");
	}
}

export default Sidebar;
</script>

<style lang="stylus" scoped>
.sidebar
	overflow-y scroll
	border-right 0.1rem solid #ccc
	flex-shrink 0
	flex-grow 0
	width 25rem
	max-width 90%
	// padding-bottom 2em
	transform-origin left center
	transition width 0.2s ease
	display flex
	flex-direction column

	&.collapsed
		width 0rem
		border-right none

.sidebar-toggle
	z-index 2035
	position fixed
	bottom 0.5em
	left 0.5em
	transition all 0.2s ease
	background $t-very-light-bg-color
	border-radius .5rem
	box-shadow 0 0.1em 0.1em rgba(0, 0, 0, 0.3)

	.button
		width 2.5em
		height 2.5em
</style>
